// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__70vjY","toggle":"styles_toggle__1enpx","preview":"styles_preview__2JPSA"};